import styled from 'styled-components';

import {
  TurkTelekomIcon,
  TurkTelekomPrimeIcon,
  TTBusiness,
} from '@assets/icons';

export const sharedProps = {
  width: 674,
  promotionDescription:
    "Kampanyadan faydalanabilmek için Bi’Dünya Fırsat mobil uygulaması üzerinden veya Online İşlemler Bana Özel menüsünden Fırsat Kodu Al butonunu tıklayarak ya da cep telefonundan SETUR boşluk TCKN yazıp 6262'ye kısa mesaj göndererek fırsat kodu alınabilir.",
};

const Span = styled.span`
  &:before {
    content: ' ';
    white-space: pre;
  }
  @media only screen and (max-width: 425px) {
    &::before {
      content: '';
    }
    line-height: 1.57;
  }
`;

export const PromotionsConfigs = {
  prime: {
    title: (
      <>
        <span>Türk Telekom Prime</span>
        <Span>Hesap Doğrulama</Span>
      </>
    ),
    Logo: TurkTelekomPrimeIcon,
    promotionTitle: 'Türk Telekom Prime kodunuz yok mu?',
    opening: 'Türk Telekom Prime',
    logoWidth: 110,
    promotionCodeLabel: 'Türk Telekom Prime Kodu',
  },
  turktelekom: {
    title: (
      <>
        <span>Türk Telekom</span>
        <Span>Hesap Doğrulama</Span>
      </>
    ),
    Logo: TurkTelekomIcon,
    promotionTitle: 'Türk Telekom kodunuz yok mu?',
    opening: 'Türk Telekom’la',
    logoWidth: 195,
    promotionCodeLabel: 'Türk Telekom Kodu',
  },

  business: {
    title: (
      <>
        <span>Türk Telekom Business</span>
        <Span>Hesap Doğrulama</Span>
      </>
    ),
    Logo: TTBusiness,
    promotionTitle: 'Türk Telekom Business kodunuz yok mu?',
    opening: 'Türk Telekomla Business',
    logoWidth: 195,
    promotionCodeLabel: 'Türk Telekom Business Kodu',
  },
};

export type Promotion = keyof typeof PromotionsConfigs;
